import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import Box from '@mui/material/Box'
import PropTypes from 'prop-types'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { Dialog, DialogContent, useMediaQuery, useTheme } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'
import SouthAmericaIcon from '@mui/icons-material/SouthAmerica'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import SettingsInputCompositeIcon from '@mui/icons-material/SettingsInputComposite'
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet'
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows'
import FlipCameraAndroidIcon from '@mui/icons-material/FlipCameraAndroid'
import 'moment/locale/fr'
import CompteUtilisateur from './UserOptionCard/CompteUtilisateur'
import Aspect from './UserOptionCard/Aspect'
import PageDAccueil from './UserOptionCard/PageDAccueil'
import { makeGetRequest } from 'utils/api'
import { useDispatch } from 'react-redux'
import { setSiteUser } from 'reduxLib/slices/userSlice'
import { useSelector } from 'react-redux'
import LangueRegion from './UserOptionCard/LangueRegion'
import Activites from './UserOptionCard/Activites'
import Notification from './UserOptionCard/Notification'
import ComptesConnectes from './UserOptionCard/ComptesConnectes'
import IconButton from '@mui/material/IconButton'
import MoreIcon from '@mui/icons-material/MoreVert'
import ListItemText from '@mui/material/ListItemText'
import ListItemIcon from '@mui/material/ListItemIcon'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import MenuIcon from '@mui/icons-material/Menu'
import { useNavigate } from 'react-router-dom'
import Abonnement from './UserOptionCard/Abonnement'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  py: 2,
  borderRadius: '10px',
}
export default function UserOptions({ user, setUoption, setUser }) {
  const navigate = useNavigate()
  // LAP-733 (GE022) — settings dialog labels are localised.
  const { t } = useTranslation('layout')

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const siteUser = useSelector((store) => store.user)
  const cur_user = siteUser.user?.user_parameter
  const [open, setOpen] = React.useState(true)
  const [appUser, setAppUser] = React.useState(user)
  const [userAspect, setUserAspect] = React.useState('')
  const [countrys, setCountrys] = React.useState([])
  const [anchorEl, setAnchorEl] = React.useState(null)
  const anchorEle = React.useRef(null)

  const openMenu = Boolean(anchorEl)
  const handleClickMenu = (event) => {
    // anchorEl.current = event.currentTarget
    // openMenu.current = true
    setAnchorEl(event.currentTarget)
  }
  // useEffect(() => {
  //   if (isMobile) {
  //     setAnchorEl(true)
  //   }
  // }, [])
  const handleCloseMenu = () => {
    setAnchorEl(null)
  }
  // console.log(openMenu)
  const handleOpenTab = (tab) => {
    setValue(tab)
    handleCloseMenu()
  }
  const handleOpen = () => setOpen(true)
  const dispatch = useDispatch()
  const handleClose = () => {
    setOpen(false)
    setUoption(false)
    let return_url = localStorage.getItem('return_url')
    if (return_url) {
      localStorage.removeItem('return_url')
      navigate(return_url)
      return
    }
  }

  useEffect(() => {
    // console.log(user)
    let opencc = localStorage.getItem('opencc')
    if (opencc) {
      handleOpenTab(6)
      localStorage.removeItem('opencc')
    }
    // LAP-733 (GE022) — deep-link from the NavBar "Abonnement" menu item.
    let openab = localStorage.getItem('openab')
    if (openab) {
      handleOpenTab(4)
      localStorage.removeItem('openab')
    }
    fetchUsers()
    getCountry()
  }, [])

  const fetchUsers = async () => {
    const response = await makeGetRequest('/api/user/user/', {}, true)

    if (response.status === 200) {
      let userc = response.data
      if (userc?.user_parameter?.aspect) {
        setUserAspect(userc?.user_parameter?.aspect_obj.name)
      }
      dispatch(setSiteUser(response.data))
      setAppUser(response.data)
      setUser(response.data)
    }
  }
  const [value, setValue] = React.useState(0)
  const [value1, setValue1] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const handleChange1 = (event, newValue) => {
    setValue1(newValue)
  }
  const getCountry = async () => {
    const res = await makeGetRequest('/api/base/get-country/', {}, true)
    if (res.status === 200) {
      let data = []
      res.data.forEach((e) => {
        data.push({ ...e, label: `${e.CountryCode} | ${e.Designation}` })
      })
      setCountrys(data)
    }
  }
  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`,
    }
  }
  function a11yProps1(index) {
    return {
      id: `horizental-tab-${index}`,
      'aria-controls': `horizental-tabpanel-${index}`,
    }
  }
  function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && <Box height={'100%'}>{children}</Box>}
      </div>
    )
  }
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  }
  return (
    <>
      <Dialog
        fullWidth
        maxWidth="lg"
        className="aaabb"
        sx={{ '.MuiPaper-root': { width: isMobile ? '100%' : '100%', m: isMobile ? 1 : 2 } }}
        open={open}
        onClose={handleClose}
      >
        <DialogContent sx={{ p: isMobile ? 1 : 3 }}>
          <Box>
            <Box
              sx={{
                mb: 2,
                display: 'flex',
                // justifyContent: { xs: 'space-between', md: 'center' },
                fontWeight: '800',
                fontSize: '26px',
              }}
            >
              <IconButton
                // ref={anchorEle}
                size="large"
                id="basic-buttonlfe"
                aria-controls={openMenu ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openMenu ? 'true' : undefined}
                onClick={handleClickMenu}
                color="inherit"
                sx={{ display: { md: 'none', sx: 'block' } }}
              >
                <MenuIcon />
              </IconButton>
              {t('settings.title')}
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleCloseMenu}
                MenuListProps={{
                  'aria-labelledby': 'basic-buttonlfe',
                }}
              >
                <MenuItem onClick={() => handleOpenTab(0)}>
                  <ListItemIcon>
                    <PersonIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t('settings.tabs.userAccount')}</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => handleOpenTab(1)}>
                  <ListItemIcon>
                    <FlipCameraAndroidIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t('settings.tabs.aspect')}</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => handleOpenTab(2)}>
                  <ListItemIcon>
                    <DesktopWindowsIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t('settings.tabs.homePage')}</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => handleOpenTab(3)}>
                  <ListItemIcon>
                    <SouthAmericaIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t('settings.tabs.languageRegion')}</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => handleOpenTab(4)}>
                  <ListItemIcon>
                    <SettingsEthernetIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t('settings.tabs.subscription')}</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => handleOpenTab(5)}>
                  <ListItemIcon>
                    <NotificationsActiveIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t('settings.tabs.notifications')}</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => handleOpenTab(6)}>
                  <ListItemIcon>
                    <SettingsInputCompositeIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t('settings.tabs.connectedAccounts')}</ListItemText>
                </MenuItem>
              </Menu>
            </Box>
            <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}>
              <Tabs
                orientation="vertical"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                sx={{
                  borderRight: 1,
                  borderColor: 'divider',
                  width: '350px',
                  '.Mui-selected': { background: '#eef0f1' },
                  display: { xs: 'none', md: 'flex' },
                  // minWidth: isMobile ? 350 : 0,
                }}
              >
                <Tab
                  icon={<PersonIcon />}
                  iconPosition="start"
                  sx={{ justifyContent: 'start' }}
                  label={
                    <Box
                      display={'flex'}
                      flexDirection={'column'}
                      sx={{ ml: 2, textAlign: 'left', textTransform: 'none' }}
                    >
                      <Box sx={{ fontWeight: 'bold', fontSize: '17px' }}>{t('settings.tabs.userAccount')}</Box>
                      <Box sx={{ color: 'gray' }}>
                        {appUser.prenom} {appUser.nom}
                      </Box>
                    </Box>
                  }
                  {...a11yProps(0)}
                />
                <Tab
                  icon={<FlipCameraAndroidIcon />}
                  iconPosition="start"
                  sx={{ justifyContent: 'start' }}
                  label={
                    <Box
                      display={'flex'}
                      flexDirection={'column'}
                      sx={{ ml: 2, textAlign: 'left', textTransform: 'none' }}
                    >
                      <Box sx={{ fontWeight: 'bold', fontSize: '17px' }}>{t('settings.tabs.aspect')}</Box>
                      <Box sx={{ color: 'gray' }}>{userAspect}</Box>
                    </Box>
                  }
                  {...a11yProps(1)}
                />
                <Tab
                  icon={<DesktopWindowsIcon />}
                  iconPosition="start"
                  sx={{ justifyContent: 'start' }}
                  label={
                    <Box
                      display={'flex'}
                      flexDirection={'column'}
                      sx={{ ml: 2, textAlign: 'left', textTransform: 'none' }}
                    >
                      <Box sx={{ fontWeight: 'bold', fontSize: '17px' }}>{t('settings.tabs.homePage')}</Box>
                    </Box>
                  }
                  {...a11yProps(2)}
                />
                <Tab
                  icon={<SouthAmericaIcon />}
                  iconPosition="start"
                  sx={{ justifyContent: 'start' }}
                  label={
                    <Box
                      display={'flex'}
                      flexDirection={'column'}
                      sx={{ ml: 2, textAlign: 'left', textTransform: 'none' }}
                    >
                      <Box sx={{ fontWeight: 'bold', fontSize: '17px' }}>{t('settings.tabs.languageRegion')}</Box>
                      <Box sx={{ color: 'gray' }}>
                        {t('settings.languageRegion.summary', {
                          language: t(
                            `settings.languages.${(siteUser?.user?.language || 'fr').slice(0, 2)}`,
                            { defaultValue: cur_user?.langue || '' },
                          ),
                          hourFormat: cur_user?.format_de_lheure || '',
                        })}
                      </Box>
                    </Box>
                  }
                  {...a11yProps(3)}
                />
                <Tab
                  icon={<SettingsEthernetIcon />}
                  iconPosition="start"
                  sx={{ justifyContent: 'start' }}
                  label={
                    <Box
                      display={'flex'}
                      flexDirection={'column'}
                      sx={{ ml: 2, textAlign: 'left', textTransform: 'none' }}
                    >
                      <Box sx={{ fontWeight: 'bold', fontSize: '17px' }}>{t('settings.tabs.subscription')}</Box>
                    </Box>
                  }
                  {...a11yProps(4)}
                />
                <Tab
                  icon={<NotificationsActiveIcon />}
                  iconPosition="start"
                  sx={{ justifyContent: 'start' }}
                  label={
                    <Box
                      display={'flex'}
                      flexDirection={'column'}
                      sx={{ ml: 2, textAlign: 'left', textTransform: 'none' }}
                    >
                      <Box sx={{ fontWeight: 'bold', fontSize: '17px' }}>{t('settings.tabs.notifications')}</Box>
                    </Box>
                  }
                  {...a11yProps(5)}
                />
                <Tab
                  icon={<SettingsInputCompositeIcon />}
                  iconPosition="start"
                  sx={{ justifyContent: 'start' }}
                  label={
                    <Box
                      display={'flex'}
                      flexDirection={'column'}
                      sx={{ ml: 2, textAlign: 'left', textTransform: 'none' }}
                    >
                      <Box sx={{ fontWeight: 'bold', fontSize: '17px' }}>{t('settings.tabs.connectedAccounts')}</Box>
                    </Box>
                  }
                  {...a11yProps(6)}
                />
              </Tabs>
              <TabPanel className="aaaaa" value={value} index={0} style={{ width: '100%' }}>
                <CompteUtilisateur
                  appUser={appUser}
                  setAppUser={setAppUser}
                  style={{ height: 'inherit' }}
                  handleClose={handleClose}
                  fetchUser={fetchUsers}
                  countrys={countrys}
                />
              </TabPanel>
              <TabPanel value={value} index={1} style={{ width: '100%' }}>
                <Aspect
                  appUser={appUser}
                  setAppUser={setAppUser}
                  style={{ height: 'inherit' }}
                  handleClose={handleClose}
                  fetchUser={fetchUsers}
                />
              </TabPanel>
              <TabPanel value={value} index={2} style={{ width: '100%' }}>
                <PageDAccueil
                  appUser={appUser}
                  setAppUser={setAppUser}
                  style={{ height: 'inherit' }}
                  handleClose={handleClose}
                  fetchUser={fetchUsers}
                />
              </TabPanel>
              <TabPanel value={value} index={3} style={{ width: '100%' }}>
                <LangueRegion
                  appUser={appUser}
                  setAppUser={setAppUser}
                  style={{ height: 'inherit' }}
                  handleClose={handleClose}
                  fetchUser={fetchUsers}
                />
              </TabPanel>
              <TabPanel value={value} index={4} style={{ width: '100%' }}>
                <Abonnement
                  appUser={appUser}
                  setAppUser={setAppUser}
                  style={{ height: 'inherit' }}
                  handleClose={handleClose}
                  fetchUser={fetchUsers}
                />
              </TabPanel>
              <TabPanel value={value} index={5} style={{ width: '100%' }}>
                <Notification
                  appUser={appUser}
                  setAppUser={setAppUser}
                  style={{ height: 'inherit' }}
                  handleClose={handleClose}
                  fetchUser={fetchUsers}
                />
              </TabPanel>
              <TabPanel value={value} index={6} style={{ width: '100%' }}>
                <ComptesConnectes
                  appUser={appUser}
                  setAppUser={setAppUser}
                  style={{ height: 'inherit' }}
                  handleClose={handleClose}
                  fetchUser={fetchUsers}
                />
              </TabPanel>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}
